type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>
    }
  : T

const isObject = (item: any) => {
  return item && typeof item === 'object' && !Array.isArray(item)
}

export const deepMerge = <T extends object>(
  target: T,
  ...sources: Array<DeepPartial<T>>
): T => {
  if (!sources.length) {
    return target
  }
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key as unknown as keyof T]) {
          Object.assign(target, { [key]: {} })
        }
        deepMerge(target[key as unknown as keyof T] as object, source[key] as object)
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return deepMerge(target, ...sources)
}
